import { Component, Input } from '@angular/core';
import packageJson from '../../../../../package.json';

@Component({
  selector: 'app-pie-pagina',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
  standalone: false,
})
export class AppFooterComponent {
  /**
   * login: ion-footer en pantallas de acceso.
   * app: pie al final del scroll dentro del ion-content de cada página autenticada.
   */
  @Input() variant: 'login' | 'app' = 'app';

  readonly version = packageJson.version;
}
